module.exports = __webpack_public_path__ + "static/avatar-a187537ad24c95ca3555a3284c0cb380.jpg";